import { exitsRateConfig } from '@/lib/analytics/kpis/instagram/stories/exitsRate';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const exitsRateMVConfig = {
    ...exitsRateConfig,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
